// fetchCountries.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetch_all_countries } from "../../endpoints/API";

export const fetchCountries = async (setCountries, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await fetch_all_countries();
    if (response.statusText=="OK") {
      const data = response?.data;
      setCountries(data); // Update state with fetched countries
    } else {
      message.error("Failed to fetch countries.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching countries.");
  }
};
